import { getDataFromServer } from '../../../util';
import {
  CLUSTER_DATA_KEYS,
  getClusterQuadrant,
  getQuadrantText
} from '../../../../pages/crs/crsListingPage/CustomerListView/util';
import { capitalize } from 'lodash';

export class CustomerListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  getClusterData = (cluster) => {
    const clusterQuadrant = getClusterQuadrant(
      cluster,
      false,
      CLUSTER_DATA_KEYS.xKey,
      CLUSTER_DATA_KEYS.yKey
    );
    const quadrantText = getQuadrantText(clusterQuadrant);
    const clusterVolume = cluster[CLUSTER_DATA_KEYS.zKey];
    const alertYield = parseFloat(
      cluster[CLUSTER_DATA_KEYS.yKey]
    ).toFixedNoRounding(2);

    return `Q${clusterQuadrant} ${quadrantText} ${clusterVolume}, ${alertYield}%`;
  };

  getRiskScoreHistory = (payload, dataItem) => {
    return payload?.isDownload
      ? dataItem?.riskScoreHistory?.[dataItem?.riskScoreHistory?.length - 1]
          ?.change
      : dataItem?.riskScoreHistory;
  };

  fetchCustomerList = async (payload) => {
    const params = {
      limit: 50,
      offset: 0
    };

    if (payload) {
      const {
        limit,
        offset,
        clusterId,
        segmentId,
        searchText,
        riskLevel,
        filters
      } = payload;

      if (limit) {
        params.limit = limit;
      }

      if (offset) {
        params.offset = offset;
      }

      if (clusterId) {
        params.clusterId = clusterId;
      }

      if (segmentId) {
        params.segment = segmentId;
      }

      if (searchText) {
        params.customerKey = searchText;
      }

      if (riskLevel) {
        params.riskLevel = riskLevel;
      }

      if (filters) {
        params.filters = filters;
      }
    }

    const url = `${this.baseURL}/customers`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    const { customerList = [], count = 0 } = data || {};

    if (Array.isArray(customerList)) {
      const customerListData = customerList.map((dataItem) => {
        return {
          ...dataItem,
          customerData: {
            customerName:
              dataItem.customerName !== undefined
                ? dataItem.customerName
                : null,
            customerKey:
              dataItem.customerKey !== undefined ? dataItem.customerKey : null
          },
          riskData: {
            riskScore:
              dataItem.overallRiskScore !== undefined
                ? dataItem.overallRiskScore
                : null,
            riskLevel:
              dataItem.overallRiskLevel !== undefined
                ? dataItem.overallRiskLevelLabel ||
                  capitalize(dataItem.overallRiskLevel)
                : null
          },
          cluster: payload?.isDownload ? this.getClusterData(dataItem) : null,
          riskScoreHistory:
            dataItem?.riskScoreHistory !== undefined
              ? this.getRiskScoreHistory(payload, dataItem)
              : null,
          overallRiskLevel:
            dataItem.overallRiskLevelLabel ||
            capitalize(dataItem.overallRiskLevel)
        };
      });

      return {
        data: customerListData,
        count
      };
    }

    return {};
  };
}
